<template>
  <v-flex v-if="shouldShowBubble" shrink>
    <app-notification-bubble>{{ badgeDisplayValue }}</app-notification-bubble>
  </v-flex>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    badge: { type: Number, required: false, default: null }
  },
  computed: {
    ...mapState({
      trialNotificationPreferences: state => state.trialNotificationPreferences
    }),
    shouldShowBubble() {
      return (
        this.badge &&
        this.badge > 0 &&
        !_.isEmpty(
          _.filter(this.trialNotificationPreferences, (value, key) => value.internalNotifications)
        )
      )
    },
    badgeDisplayValue() {
      return this.badge > 99 ? '99+' : this.badge
    }
  }
}
</script>
